import { Component } from '@angular/core';
import { BaseComponent } from '../../core/base-component';

@Component({
  standalone: false,
  selector: 'mtn-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends BaseComponent {

  constructor() {
    super();
  }

}
